module.exports = __webpack_public_path__ + "img/bg6.b9495b71.png";